import GeneralRoutes from './General/routes'
import AuxiliarRoutes from './Auxiliar/routes'
import DocumentsRoutes from './Documents/routes'
import WhitelabelRoutes from './Whitelabel/routes'
import JobsRoutes from './Jobs/routes'

const Index = () => import('~pages/Admin/Index.vue')
const NavBar = () => import('~components/navbar/NavBar.vue')

export default [
  {
    name: 'admin-root',
    path: '/admin',
    components: {
      default: Index,
      navbar: NavBar
    },
    props: {
      toolbar: {
        color: 'blue',
        backgroundColor: '#f5f5f5'
      }
    },
    children: [...GeneralRoutes, ...AuxiliarRoutes, ...DocumentsRoutes, ...WhitelabelRoutes, ...JobsRoutes]
  }
]
